import {
    LEAD_CREATE_COUNTY_CREATE_REQUEST,
    LEAD_CREATE_COUNTY_CREATE_SUCCESS,
    LEAD_CREATE_COUNTY_CREATE_FAILURE,
} from '../constants/lead_create_county_create.constants';

export const createNewCountyRequest = params => ({ type: LEAD_CREATE_COUNTY_CREATE_REQUEST, params });
export const createNewCountySuccess = payload => ({ type: LEAD_CREATE_COUNTY_CREATE_SUCCESS, payload });
export const createNewCountyFailure = error => ({ type: LEAD_CREATE_COUNTY_CREATE_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/actions/create_new_county.actions.js